import React, { useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import xtareaContext from '../../context/extratareas/xtareaContext';
import consumoContext from '../../context/consumos/consumoContext';

const Proyecto = ({proyecto}) => {
    // obtener el state
    const proyectosContext = useContext(proyectoContext);
    const { proyectoActual } = proyectosContext;

    // obtener la funcion del context de xtarea
    const xtareasContext = useContext(xtareaContext);
    const {obtenerXtareas} = xtareasContext;

     // extraer el estado de consumos
    const consumosContext = useContext(consumoContext);
    const { obtenerConsumosPyt } = consumosContext;

    // funcion para agregar el proyecto actual
    const seleccionarProyecto = id => {
        proyectoActual(id); // fijar un proyecto
        obtenerXtareas(id); // filtrar las tareas
        obtenerConsumosPyt(id);// filtrar los consumos
    }
    return (  
        <li>
            <button
                type="button"
                className="btn btn-outline-primary btn-blank"
                onClick={() => seleccionarProyecto(proyecto._id)}
            >{proyecto.nombre}</button>
        </li>
    );
}
 
export default Proyecto;